export default {

    LOAD_REPORT_ANALYTICAL_CASH_FLOW(state, report_analytical_cash_flow) {
        state.items = report_analytical_cash_flow;
    }

}